<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="cateTable"
          :remote-create-item="cateCreateItem"
          :remote-update-item="cateUpdateItem"
          :remote-delete-item="cateDeleteItem"
          :remote-get-item="cateGetItem"
          :fetch-list="cateFetchList"
          :enable-search="false"
          edit-with="1000px"
          :form-config="cateFormConfig"
          :input-configs="cateInputConfigs"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
        >
        </CRUDTable>
      </v-card-text>
      <v-card-text>
        <CRUDTable
          ref="typeTable"
          :remote-create-item="createItem"
          :remote-update-item="updateItem"
          :remote-delete-item="deleteItem"
          :remote-get-item="getItem"
          :fetch-list="fetchList"
          :enable-search="false"
          edit-with="1000px"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
        >
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/commissionSchemaType'
import { createItem as cateCreateItem, deleteItem as cateDeleteItem, fetchList as cateFetchList, getItem as cateGetItem, updateItem as cateUpdateItem } from '@/api/commissionSchemaCategory'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { loading } from '@/utils/helper'

const cateTable = ref(null)
const typeTable = ref(null)

function onEditDialog(action) {
  console.log('action', action)
}
const searchKeyWord = ref('')

const formConfig = ref({
  title: 'Commission Schema Type',
  headers: [
    { value: 'id', text: 'id' },
    { value: 'name', text: 'Name' },
    { value: 'description', text: 'Description' },
    { value: 'actions', text: 'Actions', sortable: false },
  ],
})
const inputConfigs = ref([
  { md: 12, propName: 'commissionSchemaCategoryID', label: 'Commission Schema Category', type: { name: 'select', items: [] } },
  { md: 6, propName: 'name', label: 'Name' },
  { md: 6, propName: 'salesTarget', label: 'Sales Target', type: { inputType: 'number' } },
  { md: 4, propName: 'includeBasicSalary', label: 'Include Basic Salary', type: { name: 'switch' } },
  { md: 4, propName: 'calcBySalesTarget', label: 'Calc By Sales Target', type: { name: 'switch' } },
  { md: 4, propName: 'byCommissionCenter', label: 'By Commission Center', type: { name: 'switch' } },
  { md: 6, propName: 'description', label: 'Description', type: { name: 'textarea' } },
])

const cateFormConfig = ref({
  title: 'Commission Schema Category',
  headers: [
    { value: 'id', text: 'id' },
    { value: 'name', text: 'Name' },
    { value: 'actions', text: 'Actions', sortable: false },
  ],
})

const cateInputConfigs = ref([
  { md: 12, propName: 'name', label: 'Name' },
])

function refresh() {
  // loading(true)
  cateFetchList({ page: 0, limit: 0 }).then(res => {
    console.log('cateTable', res)
    const { items } = res.data
    const cateList = items.map(item => ({
      ...item,
      label: item.name,
      itemText: item.name,
      itemValue: item.id,
    }))
    inputConfigs.value[0].type.items = cateList
  }).catch(err => {
    // loading(false)
  })
}
function handleReset() {
  console.log('handleReset')
  refresh()
}
onMounted(() => {
  refresh()
})
</script>
